import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReportTable = _resolveComponent("ReportTable")!
  const _component_AdminTableLayout = _resolveComponent("AdminTableLayout")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    ref: "formDialogRefs",
    title: "失败原因",
    width: "800px",
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visibleRef) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_AdminTableLayout, {
        needSearchForm: false,
        isDialog: true,
        style: {"height":"450px"}
      }, {
        "content-table": _withCtx(() => [
          _createVNode(_component_ReportTable, {
            loading: _ctx.loading,
            tableData: _ctx.formData,
            showTableColumn: _ctx.showTableColumn
          }, null, 8, ["loading", "tableData", "showTableColumn"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}